(() => {
  if (window.phqArticleProductsLoaded) return;
  window.phqArticleProductsLoaded = true;

  const requests = new Map();
  const processed = new WeakSet();
  const root = window.Shopify?.routes?.root || '/';

  function productRequest(handle) {
    const url = `${root}products/${encodeURIComponent(handle)}.js`;
    if (!requests.has(url)) {
      requests.set(url, (async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Product unavailable');
          return await response.json();
        } finally {
          clearTimeout(timeout);
        }
      })());
    }
    return requests.get(url);
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  async function enhance(block, section) {
    if (processed.has(block)) return;
    processed.add(block);
    const fallback = block.querySelector('a.corenza-product-block__link');
    if (!fallback) return;

    try {
      const source = new URL(fallback.getAttribute('href'), window.location.origin);
      const match = source.pathname.match(/^\/products\/([^/]+)\/?$/);
      if (source.origin !== window.location.origin || !match) return;
      const handle = decodeURIComponent(match[1]);
      const productUrl = `${root}products/${encodeURIComponent(handle)}`;
      fallback.href = productUrl;
      const product = await productRequest(handle);
      if (!product || typeof product.title !== 'string' || !Number.isFinite(product.price_min) || product.price_min < 0) return;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: section.dataset.productCurrency,
      });

      const card = element('div', 'phq-article-product phq-article-product--no-image');
      if (section.dataset.productFeatured) {
        card.append(element('p', 'phq-article-product__eyebrow', section.dataset.productFeatured));
      }
      if (product.featured_image) {
        const imageUrl = new URL(product.featured_image, window.location.origin);
        if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
          imageUrl.searchParams.set('width', '480');
          const imageLink = element('a', 'phq-article-product__image-link');
          imageLink.href = productUrl;
          const image = element('img', 'phq-article-product__image');
          image.src = imageUrl.href;
          image.alt = product.title;
          image.width = 240;
          image.height = 240;
          image.loading = 'lazy';
          image.addEventListener('error', () => {
            imageLink.remove();
            card.classList.add('phq-article-product--no-image');
          }, { once: true });
          imageLink.append(image);
          card.append(imageLink);
          card.classList.remove('phq-article-product--no-image');
        }
      }

      const details = element('div', 'phq-article-product__details');
      const title = element('a', 'phq-article-product__title', product.title);
      title.href = productUrl;
      const price = element('p', 'phq-article-product__price',
        `${product.price_varies ? `${section.dataset.productFrom} ` : ''}${money.format(product.price_min / 100)}`);
      const availability = element('p', 'phq-article-product__availability',
        product.available ? section.dataset.productAvailable : section.dataset.productUnavailable);
      availability.classList.toggle('is-available', product.available === true);
      const button = element('a', 'phq-button phq-button--yellow phq-button--compact phq-article-product__button', section.dataset.productView);
      button.href = productUrl;
      button.setAttribute('aria-label', `${section.dataset.productView}: ${product.title}`);
      details.append(title);
      card.append(details, availability, price, button);
      block.replaceChildren(card);
    } catch {
      // The exported product link remains usable if Shopify cannot supply current data.
    }
  }

  function initialise(scope) {
    scope.querySelectorAll('[data-article-section-id]').forEach(section => {
      section.querySelectorAll('.corenza-product-block').forEach(block => enhance(block, section));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', () => initialise(document));
})();
